/* eslint-disable camelcase */
import React from 'react';

import DimpleDivider from '@tds/core-dimple-divider';
import Box from '@tds/core-box';
import UnorderedList from '@tds/core-unordered-list';
import OrderedList from '@tds/core-ordered-list';
import Strong from '@tds/core-strong';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const LandingText = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    wirelessLandingText: {
      headerText1,
      unorderedListItem1,
      unorderedListItem2,
      unorderedListItem3,
      unorderedListItem3_1,
      unorderedListItem3_2,
      unorderedListItem3_3,
      headerText2,
      orderedListItem1,
      orderedListItem2,
      orderedListItem3,
      orderedListItem4,
      orderedListItem4_1Strong,
      orderedListItem4_1
    }
  } = localizedStrings;

  return (
    <>
      <DimpleDivider />
      <Box tag="section" inset={2} between={3}>
        <Strong>{headerText1}</Strong>
        <UnorderedList>
          <UnorderedList.Item>{unorderedListItem1}</UnorderedList.Item>
          <UnorderedList.Item>{unorderedListItem2}</UnorderedList.Item>
          <UnorderedList.Item>
            {unorderedListItem3}
            <UnorderedList>
              <UnorderedList.Item>{unorderedListItem3_1}</UnorderedList.Item>
              <UnorderedList.Item>{unorderedListItem3_2}</UnorderedList.Item>
              <UnorderedList.Item>{unorderedListItem3_3}</UnorderedList.Item>
            </UnorderedList>
          </UnorderedList.Item>
        </UnorderedList>
        <Strong>{headerText2}</Strong>
        <OrderedList>
          <OrderedList.Item>{orderedListItem1}</OrderedList.Item>
          <OrderedList.Item>{orderedListItem2}</OrderedList.Item>
          <OrderedList.Item>{orderedListItem3}</OrderedList.Item>
          <OrderedList.Item>
            {orderedListItem4}
            <UnorderedList>
              <UnorderedList.Item>
                <Strong>{orderedListItem4_1Strong}</Strong>
                {orderedListItem4_1}
              </UnorderedList.Item>
            </UnorderedList>
          </OrderedList.Item>
        </OrderedList>
      </Box>
    </>
  );
};

export default LandingText;
